<script setup lang="ts">
import { useAgreementStore } from '@/stores/agreement';
import { storeToRefs } from 'pinia';
import { formatNumber, formatCurrency } from '@/helpers';
import SamAgreementComponent from './SamAgreementComponent.vue';

const { agreement, agreementType, basePrice, selectedAddons, addonsPrice, nextPayment } = storeToRefs(useAgreementStore())
</script>

<template>
  <v-card :title="agreementType?.name" append-icon="mdi-certificate-outline">
    <v-card-text>
      <table density="compact" class="w-100">
        <tbody>
          <tr>
            <td>
              <strong>
                Aftalestart
              </strong>
            </td>
            <td class="text-right text-capitalize">
              {{ new Date(agreement.startYear as number, agreement.startMonth as number).toLocaleDateString('da-DK', { year: 'numeric', month: 'long' }) }}
            </td>
          </tr>
          <tr>
            <td>
              <strong>
                Løbetid
              </strong>
            </td>
            <td class="text-right">
              {{ agreement.duration }} år
            </td>
          </tr>
          <tr>
            <td>
              <strong>
                Kilometer pr. år
              </strong>
            </td>
            <td class="text-right">
              {{ formatNumber(agreement.yearlyMileage) }} km
            </td>
          </tr>
          <tr>
            <td>
              <strong>
                Grundpris pr. måned
              </strong>
            </td>
            <td class="text-right">
              {{ formatCurrency(basePrice) }}
            </td>
          </tr>
          <tr>
            <td>
              <strong>Tillægsydelser</strong>
            </td>
            <td class="text-right">
              <span v-if="!selectedAddons.length">
                {{ formatCurrency(0) }}
              </span>
            </td>
          </tr>
          <tr
            v-for="addon in selectedAddons"
            :key="addon.id"
          >
            <td>
              {{ addon.name }}
            </td>
            <td class="text-right" style="vertical-align: top;">
              {{ formatCurrency(addon.price) }}
            </td>
          </tr>
          <tr>
            <td>
              <h3 class="mt-3">Total pr. måned</h3>
            </td>
            <td class="text-right">
              <h3 class="mt-3">{{ formatCurrency(basePrice + addonsPrice) }}</h3>
            </td>
          </tr>
          <tr>
            <td>
              <h3 class="mt-3">Første opkrævning</h3>
            </td>
            <td class="text-right">
              <h3 class="mt-3">{{ formatCurrency(nextPayment) }}</h3>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <small>
                Beløbet dækker månedlig opkrævning for det antal måneder der ligger før nuværende måned.
              </small>
            </td>
          </tr>
        </tbody>
      </table>
    </v-card-text>
    <v-card-actions>
      <SamAgreementComponent />
    </v-card-actions>
  </v-card>
</template>